import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { handleAxiosError } from "../../../config/action-config";
import { getLeaveById } from "../../../api/leaves";
import ViewLeaveDetail from "./view.my.leaves.detail";
const emptyNewLeaveData = {
  type_of_leave: "",
  reason_of_leave: "",
  start_date: "",
  end_date: "",
  status: "",
  day_off: "",
};

export default function ViewCustomLeavesLeads() {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getLeaveById(params.id, user.token);

      setData(data.data[0]);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return data ? (
    <ViewLeaveDetail preloadedValues={data} refresh={loadMasterData} />
  ) : (
    <div className="center">Loading.....</div>
  );
}
